// eslint-disable-next-line
import { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import { Helmet } from "react-helmet";
import Trailer1 from "../static/cropped_trailers_resized.webp";
import { ReactGoogleReviews } from "react-google-reviews";
import { transformReviews } from "../api/convertReviewSchema";
import { staticReviewData } from "../api/reviewData";
import "react-google-reviews/dist/index.css";
import trailerData from "../api/frontPageTrailerData";
import FrontPageTrailerCard from "../components/FrontPageProductCard";


export const Home = () => {
  // eslint-disable-next-line
  const [reviewData, setReviewData] = useState(staticReviewData);

  // We can invoke when more reviews come in
  // useEffect(() => {
  //   fetch('/.netlify/functions/google-review', {
  //     method: 'POST',
  //     headers: { 'Content-Type': 'application/json' },
  //   })
  //     .then(response => response.json())
  //     .then(data => {
  //       if (data && data.reviews) {
  //         setReviewData(data.reviews);
  //       } else {
  //         setReviewData(staticReviewData);
  //       }
  //     })
  //     .catch(error => {
  //       console.warn('Error fetching reviews:', error);
  //       setReviewData(staticReviewData);
  //     });
  // }, []);

  const getReviews = () => transformReviews(reviewData || staticReviewData);

  return (
    <Box sx={{
      marginBottom: "3em",
    }}>
      <Box className="home-component">
        <Helmet>
          <title>Dealer for Custom-Built Cargo Trailers, Utility Trailers, and Concession Trailers | Douglas, GA</title>
          <link rel="canonical" href="https://www.pyramidcargosolutions.com" />
          <meta name="description" content="We sell cargo, utility, enclosed, concession, and car hauler trailers. We source from over a dozen trailer manufacturers so that we can always build with quality materials and get the best price. Additionally, we support a variety of financing options to provide the most flexible plan that is right for you.
          Contact us so we can give you more information and support your business and personal trailer needs today!"></meta>
        </Helmet>
        
        <div id="main-image">
          <img
          id="home-trailer-image"
          src={Trailer1}
          alt='row of cargo trailers'>
          </img>
        </div>
        
        <Box id="about-us">
          <Typography variant="h1" component="h1" align="center" gutterBottom
          sx={{ fontSize: '2.25em', fontWeight: '400' }}>
            About Us
          </Typography>
          <p>
            Located in Douglas, GA, we sell custom trailer builds for cargo trailers, utility trailers, concession trailers, or car hauler trailers. We source from over a dozen manufacturers with close relationships which gets you quality materials for the lowest price possible. We also support a variety of <a href="/financing">financing options</a> to provide the most flexible plan that is right for you. Visit our dealership or contact us today to start your custom trailer build!
          </p>
        </Box>      
      </Box>

      <Typography variant="h4" component="h2" align="center" gutterBottom>
        What Our Customers Are Saying
      </Typography>

      <ReactGoogleReviews layout="carousel" carouselAutoplay={false} reviews={getReviews()} />
      <br />
      <ReactGoogleReviews layout="badge" badgeLabel="Pyramid Cargo Solutions" averageRating={4.8} totalReviewCount={25} reviews={getReviews()} profileUrl="https://www.google.com/maps/place/Pyramid+Cargo+Solutions/@31.5404828,-82.9280764,17z/data=!4m6!3m5!1s0x88f1d3117b291bcb:0xc017a3fc4f7a6f29!8m2!3d31.5404828!4d-82.9255015!16s%2Fg%2F11kc159mwq?entry=ttu&g_ep=EgoyMDI1MDgyNC4wIKXMDSoASAFQAw%3D%3D" />

      <Box sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        marginTop: '2em',
      }}>
        <Typography variant="h4" component="h2" align="center" gutterBottom>
          Best Selling Trailers
        </Typography>

        <Box sx={{
          display: 'flex',
          flexWrap: 'wrap',
          justifyContent: 'center',
          marginTop: '2em',
          gap: '2em',
        }}>
          {trailerData.map((trailer, idx) => (
            <FrontPageTrailerCard key={trailer.id || idx} trailerData={trailer} chipMessage=""/>
          ))}
        </Box>

      </Box>
    </Box>
  )
}

export default Home;